import api from '@/services/api';
import type { ApiItemResponse, FranchiseListResponse } from '../types/dealers.types';

const dealerUrl = (id: string): string => `/dealers/${id}`;

export const listFranchisors = async (
    dealerId: string,
    page = 1,
    perPage = 20,
): Promise<FranchiseListResponse> => {
    const response = await api.get<FranchiseListResponse>(`${dealerUrl(dealerId)}/franchises`, {
        params: { page, per_page: perPage },
    });

    if (!response.data.success) {
        throw new Error('Failed to fetch franchisors');
    }

    return response.data;
};

export const listFranchisees = async (
    oemId: string,
    page = 1,
    perPage = 20,
): Promise<FranchiseListResponse> => {
    const response = await api.get<FranchiseListResponse>(`${dealerUrl(oemId)}/franchisees`, {
        params: { page, per_page: perPage },
    });

    if (!response.data.success) {
        throw new Error('Failed to fetch franchisees');
    }

    return response.data;
};

// Attach/detach are ALWAYS keyed on the franchise_dealer endpoint (the one
// symmetric relationship row), regardless of which tab (OEMs or Franchises)
// initiates the call.
export const attachFranchise = async (franchiseDealerId: string, oemId: string): Promise<void> => {
    const response = await api.post<ApiItemResponse<unknown>>(`${dealerUrl(franchiseDealerId)}/franchises`, {
        oem_id: oemId,
    });

    if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to attach franchise');
    }
};

export const detachFranchise = async (franchiseDealerId: string, oemId: string): Promise<void> => {
    const response = await api.delete<ApiItemResponse<null>>(`${dealerUrl(franchiseDealerId)}/franchises/${oemId}`);

    if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to detach franchise');
    }
};
